<div>
    <div class="filter-header filter-header-section">
        <div class="row">
            <span class="text-uppercase col-sm-6 filter-header-label">{{ filterConfig.label }}</span>
            <span title="Clear All Filters" (cclClick)="clearAllFilter()" role="button" class="clear-all-filter col-sm-6"
                ><span id="clear-all-label" class="pull-right clear-filter">{{ 'filter_section.clear_all' | translate }}</span></span
            >
        </div>
    </div>
    <div class="filter-body filter-body-section">
        <div *ngFor="let filterType of filterConfig.selectedFields; let i = index">
            <div
                [ngClass]="
                    i == filterConfig.selectedFields.length
                        ? 'text-uppercase ptb10'
                        : showFilterContent[filterType.field] && (filterType.field == 'sessionDate' || filterType.field == 'sessionTime') ? 'text-uppercase ptb10' : 'text-uppercase ptb10 filterItemRow'
                "
                *ngIf="(filterData[filterType.field] != null && filterData[filterType.field].length > 0) || filterType.field == 'sessionDateRange'"
            >
                <div [title]="showFilterContent[filterType.field] ? 'Collapse' : 'Expand'" (cclClick)="toggleFilterContent(filterType.field)" class="cursor-pointer">
                    <span translate>
                        {{ filterType.type == "standardFields" ? filterType.field_label :
                        customFieldLabels[filterType.field] }}
                        <i
                            [title]="
                                !showFilterContent[filterType.field]
                                    ? 'Expand'
                                    : 'Collapse'"
                            class="fa removeIcon"
                            [ngClass]="{
                                'fa-chevron-right':
                                    filterConfig.expansionStyles == 1 && !showFilterContent[filterType.field],
                                'fa-chevron-down':
                                    filterConfig.expansionStyles == 1 && showFilterContent[filterType.field],
                                'fa-chevron-circle-right':
                                    filterConfig.expansionStyles == 2 && !showFilterContent[filterType.field],
                                'fa-chevron-circle-down':
                                    filterConfig.expansionStyles == 2 && showFilterContent[filterType.field]
                            }"
                        ></i
                    ></span>
                </div>
            </div>
            <div class="filter-child" *ngIf="showFilterContent[filterType.field] && filterType.field != 'sessionDate' && filterType.field != 'sessionTime' && filterType.field != 'sessionDateRange'">
                <div class="c-form-group">
                    <div class="input-group">
                        <input
                            [ngClass]="{'input-search-width':filterPlacement === 'top'}"
                            aria-label="Search"
                            [id]="'search-label-'+i"
                            role="textbox"
                            class="inline-search"
                            [(ngModel)]="filterTextSearch[filterType.field]"
                            (keyup.enter)="clickTextSearch()"
                            placeholder="Search"
                            type="text"
                        />
                    </div>
                </div>
                <div
                    *ngFor="
                        let field of filterData[filterType.field]
                            | searchText: 'label':filterTextSearch[filterType.field]
                    "
                >
                    <input
                        type="checkbox"
                        [id]="filterType.field + '_' + field.id"
                        class="c-checkbox"
                        [(ngModel)]="selectedFilterData[filterType.field][field.id]"
                    />
                    <label
                        [for]="filterType.field + '_' + field.id"
                        (cclClick)="$event.preventDefault(); selectFilter(filterType.field, field.id)"
                    >
                        <span *ngIf="standardFieldLabels[filterType.field] != 'Session Date'; else isDate">
                            {{ field.label }}
                        </span>
                        <ng-template #isDate>{{ field.label | date: tabConfig.dateFormat }}</ng-template>
                    </label>
                </div>
            </div>
            <div class="filter-child filterItemRow" *ngIf="showFilterContent[filterType.field] && filterType.field == 'sessionDate' && sessionDate.length>0">
            <div class="filter-time-zone">
                <ccl-simple-select ariaLabel="Session Date"
                [value]="sharedService.selectedDayTime.day"
                [listOfItems]="sessionDate"
                (valueChange)="sharedService.selectedDayTime.day = $event.value; selectFilter('sessionDate', $event.value)"
                [bindValue]="'id'"
                [bindLabel]="'label'"
                [isClearable]="false"
            ></ccl-simple-select>
            </div>
            </div>
            <div class="filter-child filterItemRow" [hidden]="!(showFilterContent[filterType.field] && filterType.field == 'sessionDateRange')">
                <div class="filter-time-zone">
                    <input [showClearButton]=true [minDate]='minDate' [maxDate]='maxDate'
                class="date-range-picker datepicker-calendar-icon" type="text"
                ngxDaterangepickerMd [locale]="{applyLabel: 'ok', format: 'ddd, MMM D'}" [(ngModel)]="startEndObj"
                placeholder="Choose date" (change)="change($event)" />
                </div>
            </div>
            <div class="filter-child filterItemRow" *ngIf="showFilterContent[filterType.field] && filterType.field == 'sessionTime' && sessionTime.length>0">
                <div class="filter-time-zone">
            <ccl-simple-select ariaLabel="Session Time"
                [value]="sharedService.selectedDayTime.time"
                [listOfItems]="sessionTime"
                (valueChange)="sharedService.selectedDayTime.time = $event.value; selectFilter('sessionTime', $event.value)"
                [bindValue]="'id'"
                [bindLabel]="'label'"
                [isClearable]="false"
            ></ccl-simple-select>
            </div>
            </div>
            <!-- <div class="filter-child" *ngIf="showFilterContent[filterType.field] && filterType.type == 'customFields'">
                <div *ngFor="let field of filterData[filterType.field]">
                    <ccl-checkbox
                        buttonStyle="c-checkbox"
                        (clickEvent)="selectFilter(filterType.field, field.id)"
                        [id]="filterType.field + '_' + field.id"
                        [value]="selectedFilterData[filterType.field][field.id]"
                        >{{ field.label }}</ccl-checkbox
                    >
                </div>
            </div>-->
        </div>
        <div [ngClass]="(!this.filterConfig.hasOwnProperty('showTimezoneFilter')) || (this.filterConfig.showTimezoneFilter == true) || (!this.generalDataConfig.defaultFilters.hideFullSessions) ? 'text-uppercase ptb10 filterItemRow' : 'text-uppercase ptb10'" *ngIf="((this.sharedService.loggedInAttendee != null && !this.filterConfig.hasOwnProperty('showMysessionsFilter')) || (this.sharedService.loggedInAttendee != null && this.filterConfig.showMysessionsFilter == true) && !this.loginConfig.restrictedBrowsing)">
            <div class="cursor-pointer" [title]="togglMySessionFilter ? 'Collapse' : 'Expand'" (cclClick)="mySessionToggle()">
                <span id="my-session-label">
                    {{ 'filter_section.my_session' | translate }}
                    <i role="presentation"
                        class="fa removeIcon"
                        [ngClass]="{
                            'fa-chevron-right': filterConfig.expansionStyles == 1 && !togglMySessionFilter,
                            'fa-chevron-down': filterConfig.expansionStyles == 1 && togglMySessionFilter,
                            'fa-chevron-circle-right': filterConfig.expansionStyles == 2 && !togglMySessionFilter,
                            'fa-chevron-circle-down': filterConfig.expansionStyles == 2 && togglMySessionFilter
                        }"
                    >
                    </i>
                </span>
            </div>
            <div class="filter-child" [hidden]="!togglMySessionFilter">
                <div (cclClick)="this.loginConfig.restrictedBrowsing == true ? $event.stopPropagation() : mySessions.showMySessions = true;mySessions.showMyFavorite = false">
                    <ccl-radio-button
                        buttonStyle="c-radiobutton"
                        [name]="'mySessionFilter'"
                        [id]="'one'"
                        (cclClick)="toggleMySessionFilter('scheduled')"
                        [value]="true"
                        [model]="mySessions.showMySessions"
                        ><span class="font-size-12" id="show-my-sessions-label"
                            >{{ 'filter_section.show_my_sessions' | translate }}</span
                        ></ccl-radio-button
                    >
                </div>
                <div (cclClick)="this.loginConfig.restrictedBrowsing == true ? $event.stopPropagation() : mySessions.showMySessions = false;mySessions.showMyFavorite = true">
                    <ccl-radio-button
                        buttonStyle="c-radiobutton"
                        [name]="'SessionFilter'"
                        [id]="'two'"
                        (cclClick)="toggleMySessionFilter('favorite')"
                        [value]="true"
                        [model]="mySessions.showMyFavorite"
                        ><span class="font-size-12" id="show-my-favourites-label"
                            >{{ 'filter_section.show_my_fav' | translate }}</span
                        ></ccl-radio-button
                    >
                </div>
                <div *ngIf="sharedService.excData.size > 0">
                    <span (cclClick)="removeAll(true)" class="cursor-pointer" id="unhide-sessions-label"
                        >{{ 'filter_section.unhide_session' | translate }} ({{ sharedService.excData.size }})</span
                    >
                </div>
            </div>
        </div>

        <!-- <div
        *ngIf="(!this.filterConfig.hasOwnProperty('showTimezoneFilter')) || (this.filterConfig.showTimezoneFilter == true)"
        class="text-uppercase ptb10 filterItemRow"
    >
        <div [title]="toggle ? 'Collapse' : 'Expand'" (cclClick)="toggleFunc()" class="cursor-pointer">
            <span>
                {{ 'filter_section.time_zone' | translate }}
                <i role="presentation"
                class="fa removeIcon"
                [ngClass]="{
                    'fa-chevron-right': filterConfig.expansionStyles == 1 && !toggle,
                    'fa-chevron-down': filterConfig.expansionStyles == 1 && toggle,
                    'fa-chevron-circle-right': filterConfig.expansionStyles == 2 && !toggle,
                    'fa-chevron-circle-down': filterConfig.expansionStyles == 2 && toggle
                }"
            >
            </i></span>
        </div>
        <div class="filter-child" [hidden]="toggle==false">
            <div (cclClick)="timezone.type = 'mytimezone';toggleTimeZone(timezone.type)">
                <ccl-radio-button
                    buttonStyle="c-radiobutton"
                    [name]="'one'"
                    [id]="'myTimeZone'"
                    [value]="'mytimezone'"
                    [model]="timezone.type"
                    ><span class="font-size-12" id="show-in-my-timezone-label"
                        >{{ 'filter_section.show_in_my_time_zone' | translate }}</span
                    ></ccl-radio-button
                >
            </div>
            <div (cclClick)="timezone.type = 'sessiontimezone';toggleTimeZone(timezone.type)">
                <ccl-radio-button
                    buttonStyle="c-radiobutton"
                    [name]="'two'"
                    [id]="'sessionTimeZone'"
                    [value]="'sessiontimezone'"
                    [model]="timezone.type"
                    ><span class="font-size-12" id="show-in-session-timezone-label"
                        >{{ 'filter_section.show_in_session_time_zone' | translate }}</span
                    ></ccl-radio-button
                >
            </div>

        </div>
    </div> -->
    <div [ngClass]="(!this.generalDataConfig.defaultFilters.hideFullSessions || !this.generalDataConfig.defaultFilters.hidePastSessions) && this.generalDataConfig.showHidePastFilter  ? 'text-uppercase ptb10 filterItemRow' : 'text-uppercase ptb10'" *ngIf="(!this.filterConfig.hasOwnProperty('showTimezoneFilter')) || (this.filterConfig.showTimezoneFilter == true)">
        <span class="text-uppercase">
            {{ 'filter_section.time_zone' | translate }}
        </span>
        <div class="filter-time-zone">
        <ccl-simple-select ariaLabel="TimeZone"
        [value]="timezone.type"
        [listOfItems]="timezoneArr"
        (valueChange)="timezone.type = $event.value; toggleTimeZone(timezone.type)"
        [bindValue]="'timeKeyName'"
        [bindLabel]="'displayName'"
        [isClearable]="false"
        [isSearchable]="true"
    ></ccl-simple-select>
        </div>
    </div>
    <div class="ptb10" >
        <div class="filter-time-zone" *ngIf="!this.generalDataConfig.defaultFilters.hideFullSessions && this.generalDataConfig.showHidePastFilter">
            <input
            type="checkbox"
            id="hide_full_sessions"
            class="c-checkbox"
            [(ngModel)]="hideFullSession"
        />
        <label
            for="hide full sessions"
            (cclClick)="$event.preventDefault(); hideSessions('full')"
        >
            <span>
                {{ 'filter_section.hide_full_sessions' | translate }}
            </span>
        </label>
        </div>
        <div class="filter-time-zone" *ngIf="!this.generalDataConfig.defaultFilters.hidePastSessions && this.generalDataConfig.showHidePastFilter">
            <input
            type="checkbox"
            id="hide_past_sessions"
            class="c-checkbox"
            [(ngModel)]="hidePastSession"
        />
        <label
            for="hide past sessions"
            (cclClick)="$event.preventDefault(); hideSessions('past')"
        >
            <span>
                {{ 'filter_section.hide_past_sessions' | translate }}
            </span>
        </label>
        </div>
    </div>
    </div>
</div>
